/**
 * Middleware to handle sold-out product checks and cart-related initializations.
 *
 * This middleware:
 * 1. Runs only on checkout and cart pages
 * 2. Runs only on the client-side
 * 3. Aligns promotions for the cart
 * 4. Initializes product comparisons
 *
 * @param {Object} to - The route being navigated to
 * @param {string} to.fullPath - Full path of the destination route
 * @param {string} to.path - Path of the destination route
 * @param {Object} from - The route being navigated from
 * @param {string} from.path - Path of the origin route
 *
 * @returns {Promise<void>}
 *
 * @remarks
 * - Skips execution if not on checkout or cart pages
 * - Skips if navigating within the same path
 * - Skips if cart already has sold-out compare data
 *
 * @example
 *  When navigating to '/cart' or '/checkout'
 *  Aligns cart promotions and initializes product comparisons
 */
export default defineNuxtRouteMiddleware(async (to, from) => {
  // RUN THIS MIDDLEWARE ONLY IN CART AND CHECKOUT PAGES
  if (to.name !== 'localized-checkout' && !to.fullPath.includes('cart')) return
  if (!process.client) return

  const { alignPromotionsForCart, initCompare, soldOutCompareData } = useCart()

  // not first load and  not if path remain the same but query changes
  if (to && to.path === from.path) return
  // not to cart page with soldOutCompareData
  if (to.fullPath.includes('cart') && soldOutCompareData.value?.length) return

  await alignPromotionsForCart()
  initCompare()
})
